import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { Location, type AppointmentType } from '@src/lib/__generated/vetspire/sdk';
import { mountDevTools } from '@src/store/utils/mount-dev-tools';
import { scheduleTypeOptions } from '@src/utils/determine-schedule-type';

export type State = {
	facility: Location | null;
	scheduleType: scheduleTypeOptions;
	allAppointmentTypes: AppointmentType[] | null;
	nonScheduleAppointmentTypes: AppointmentType[] | null;
};

type Actions = {
	setFacility: (facility: Location | null) => void;
	setScheduleType: (scheduleType: scheduleTypeOptions) => void;
	setAllAppointmentTypes: (appointmentTypes: AppointmentType[]) => void;
	setNonScheduleAppointmentTtypes: (appointmentTypes: AppointmentType[]) => void;
	reset: () => void;
};

const INITIAL_STATE: State = {
	facility: null,
	scheduleType: scheduleTypeOptions.closed,
	allAppointmentTypes: null,
	nonScheduleAppointmentTypes: null,
};

const useFacilityStore = create<State & Actions>()(
	persist(
		(set) => ({
			...INITIAL_STATE,
			setFacility: (facility) => set({ facility }),
			setScheduleType: (scheduleType) => set({ scheduleType }),
			setAllAppointmentTypes: (allAppointmentTypes) => set({ allAppointmentTypes }),
			setNonScheduleAppointmentTtypes: (appointmentTypes) =>
				set({ nonScheduleAppointmentTypes: appointmentTypes }),
			reset: () => set(INITIAL_STATE),
		}),
		{ name: 'facility-information-storage' }
	)
);

mountDevTools('useFacilityStore', useFacilityStore);

export default useFacilityStore;
